import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'/*引入ElementUI*/
import './assets/css/reset.css'//重置样式
Vue.config.productionTip = false;
// 引入echarts
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts;
// var echarts = require('echarts')
// 引入格式化工具
import './permission'
import common from "@/utils/common";
Vue.prototype.$common = common;
// 引入百度地图插件
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap,{
    ak:'UAVhNUawIvLFzxZPs7RqAcwzssCx7srT'		//使用申请的百度地图秘钥
});

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard);

// 引用富文本
const Editor = require('wangeditor');
Vue.prototype.$editor = Editor;

//即时聊天
import './plugins/NIM/uiKit.css'

import Router from 'vue-router'
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this,location).catch(error=>error)
};
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
